<mat-form-field
  appearance="outline"
  [hideRequiredMarker]="true"
  [formGroup]="group" 
  [ngClass]="loading ? 'nsc-form-field-loading' : ''"
  class="nsc-form-field-autocomplete"
  subscriptSizing="dynamic"
  [attr.data-label]="placeholder"
>
  <mat-label>{{ placeholder }}</mat-label>
  <input id="{{ idx }}" #itemFilterInput matInput
    [attr.aria-busy]="loading" [attr.aria-describedby]="isValueSelected() ? (idx + '_selected_hint') : null"
    [formControlName]="controlName" type="text" (blur)="onBlur()" (focus)="onFocus()" [matAutocomplete]="auto">
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [aria-labelledby]="idx + '_expanded_hint'">
    @for (option of values.autocomplete; track option; let i = $index) {
    <mat-option id="{{idx}}_{{i}}" [disabled]="option.disabled" [ngClass]="optionClass(i)" [value]="option.schlName"
      [attr.aria-label]="option.schlName === group.controls[controlName].value ? option.schlName + ' selected' : null"  
      [attr.aria-selected]="option.schlName === group.controls[controlName].value"
      (click)="!option.disabled && selectOption(option)" (mouseenter)="optionHoverHandler($event, i)">
      {{ option.schlName }}
    </mat-option>
    }
  </mat-autocomplete>
  @if (group.controls[controlName].invalid) {
  <mat-error>Error: {{ validationMessage.get(group.controls[controlName], placeholder) }}</mat-error>
  }
</mat-form-field>

<span [id]="idx + '_selected_hint'" class="cdk-visually-hidden">selected</span>

<span [id]="idx + '_expanded_hint'" class="cdk-visually-hidden">expanded</span>

<span [id]="idx + '_collapsed_hint'" class="cdk-visually-hidden" role="status" aria-live="assertive"
  aria-atomic="true">{{ collapsedLiveText }}</span>